<div class="test-wrap">
  <div id="test-player"></div>
</div>